import React, { useContext } from "react";
import "./style.css";
import { AuthContext } from "../../Library/contexts";

const InstallationVideos = () => {
  const { profile } = useContext(AuthContext);

  const INSTALLATION_VIDEOS_REVFIN = [
    { label: "Dealer Panel Tutorial", ytVideoId: "SjOxXnU62vU" },
    { label: "Device Installation & Mapping process", ytVideoId: "gx_FDPb2Y2k" },
    { label: "Installation video", ytVideoId: "bkSSRnALYoA" },
  ];

  const INSTALLATION_VIDEOS_BOUNCE = [
    { label: "Dealer Panel Tutorial", ytVideoId: "26tVbZNWy2c" },
  ];

  const getInstVideos = () => {
    if (profile.rly) return INSTALLATION_VIDEOS_REVFIN;
    else return INSTALLATION_VIDEOS_BOUNCE;
  }

  return (
    <section className="panel-main installation-videos">
      <div className="installation-videos-conatiner">
        { getInstVideos().map((video, idx) => (
          <div key={idx} className="installation-video-card">
            <div className="video-box">
              <iframe className="installation-video-iframe" allowFullScreen={true} src={`https://www.youtube.com/embed/${video.ytVideoId}`} title={video.label}></iframe>
            </div>
            <p>{video.label}</p>
          </div>
        )) }
      </div>
    </section>
  )
}

export default InstallationVideos
